import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://spjouqdizmcpehsspfed.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNwam91cWRpem1jcGVoc3NwZmVkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIzMDkzODYsImV4cCI6MjA4Nzg4NTM4Nn0.7iFv3UaOuBlJgWisoHG0WMmKy4eLdQt82pH2oWp-7OI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
